import reactHotToast, { ToastOptions } from "react-hot-toast";
import { MdInfoOutline, MdWarning } from "react-icons/md";

const toast = {
  ...reactHotToast,
  info: (message: string, options?: ToastOptions) =>
    reactHotToast(message, {
      icon: <MdInfoOutline className="h-5 w-5 text-informative-600" />,
      ...options,
    }),
  warning: (message: string, options?: ToastOptions) =>
    reactHotToast(message, {
      icon: <MdWarning className="h-5 w-5 text-warning-500" />,
      ...options,
    }),
};

export default toast;
